var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-autocomplete',{attrs:{"items":_vm.page.authors,"item-text":"name","item-value":"id","label":"Rédacteur (signature)","loading":_vm.page.loading,"no-data-text":!_vm.forceSiteId
      ? 'Sélectionnez un site'
      : _vm.page.loading
      ? 'Chargement…'
      : 'Aucun rédacteur trouvé',"outlined":"","dense":_vm.dense,"hide-details":"","clearable":"","disabled":!_vm.forceSiteId},model:{value:(_vm.authorId),callback:function ($$v) {_vm.authorId=$$v},expression:"authorId"}})}
var staticRenderFns = []

export { render, staticRenderFns }